// document.addEventListener("DOMContentLoaded", function () {
//   const buttons = document.querySelectorAll(".per-row__buttons .cst_btn");
//   const gridList = document.getElementById("ProductsList");
//   const gridContainer = document.getElementById("ProductGridContainer");
//   const productCards = gridList.querySelectorAll(".f-column.card");

//   const defaultCols = 3;
//   const savedCols = localStorage.getItem("gridColumns") || defaultCols;
//   updateGrid(savedCols);

//   buttons.forEach((btn) => {
//     btn.addEventListener("click", function () {
//       const cols = this.getAttribute("data-columns");
//       updateGrid(cols);
//       localStorage.setItem("gridColumns", cols);
//     });
//   });

//   function updateGrid(cols) {
//     // Remove old grid classes
//     gridList.className = gridList.className.replace(/f-grid-\d+-cols/g, "").trim();

//     // Add the new grid class
//     gridList.classList.add(`f-grid-${cols}-cols`);

//     // Update CSS variable
//     if (gridContainer) {
//       gridContainer.style.setProperty("--current-column", cols);
//     }

//     // Update active button
//     buttons.forEach((b) => b.classList.remove("active"));
//     const activeBtn = document.querySelector(`.per-row__buttons .btn[data-columns="${cols}"]`);
//     if (activeBtn) activeBtn.classList.add("active");

//     // Reset is_large classes
//     productCards.forEach((card) => card.classList.remove("is_large"));

//     // Add is_large based on current columns
//     if (parseInt(cols) === 4) {
//       if (productCards[0]) productCards[0].classList.add("is_large"); // 1st
//       if (productCards[9]) productCards[9].classList.add("is_large"); // 10th
//     } else if (parseInt(cols) === 3) {
//       if (productCards[1]) productCards[1].classList.add("is_large"); // 2nd
//       if (productCards[8]) productCards[8].classList.add("is_large"); // 9th
//     }
//   }
// });

document.addEventListener("DOMContentLoaded", function() {
  // product-information-blocks: Leer más (readmoreBtn + quick-view-description-text)
  document.querySelectorAll('.readmoreBtn').forEach(function(btn) {
    var contentBox = btn.previousElementSibling;
    if (!contentBox || !contentBox.classList.contains('quick-view-description-text')) return;

    var lineHeight = parseInt(window.getComputedStyle(contentBox).lineHeight, 10) || 22;
    var maxHeight = lineHeight * 2;

    if (contentBox.scrollHeight <= maxHeight) {
      btn.style.display = 'none';
      return;
    }

    btn.addEventListener('click', function() {
      contentBox.classList.toggle('text_box');
      if (contentBox.classList.contains('text_box')) {
        btn.innerHTML = 'Leer menos <span class="toggle-icon">\u2212</span>';
        btn.setAttribute('aria-expanded', 'true');
      } else {
        btn.innerHTML = 'Leer m\u00e1s <span class="toggle-icon">+</span>';
        btn.setAttribute('aria-expanded', 'false');
      }
    });
  });
});

// document.addEventListener("DOMContentLoaded", function() {
//   document.querySelectorAll('.product_detail-tabs a').forEach(link => {
//     link.addEventListener('click', function(e) {
//       e.preventDefault();
//       // get target class name from data-target
//       const targetClass = this.getAttribute('data-target');
//       const target = document.querySelector('.' + targetClass);
//       if (target) {
//         target.scrollIntoView({ behavior: 'smooth' });
//       }
//     });
//   });
// });

document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll('.product_detail-tabs a').forEach(link => {
    const targetClass = link.getAttribute('data-target');
    const target = document.querySelector('.' + targetClass);

    if (!target) {
      // Disable link if target section doesn't exist
      link.style.pointerEvents = 'none';
      link.style.cursor = 'auto';
      // link.style.color = '#999'; 
    } else {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      });
    }
  });
});

// {
//   window.setGridHeight = (selector) => {
//     const elements = Array.from(document.querySelectorAll(selector));
//     if (!elements.length) return;

//     const gridOffsets = elements.map((element) => {
//       element.style.minHeight = '';

//       const grid = element.closest('.f-column') || element.closest('[data-equal]');

//       const offsetTop = grid ? grid.offsetTop : element.offsetTop;

//       return {
//         element,
//         selectorHeight: element.offsetHeight,
//         offsetTop,
//       };
//     });

//     const rowOffsets = [...new Set(gridOffsets.map((item) => item.offsetTop))];

//     rowOffsets.forEach((rowOffset) => {
//       const rowItems = gridOffsets.filter((item) => item.offsetTop === rowOffset);
//       const maxHeight = Math.max(...rowItems.map((item) => item.selectorHeight));

//       rowItems.forEach((item) => {
//         item.element.style.minHeight = `${maxHeight}px`;
//       });
//     });
//   };

//   const matchHeightCallback = () => {
//     window.setGridHeight('.product-card__info .product-card__title');
//   };

//   matchHeightCallback();

//   setTimeout(matchHeightCallback, 2000);

//   window.addEventListener('resize', () => {
//     window.requestAnimationFrame(matchHeightCallback);
//   });
// }

// Collection page read more button
    document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".readmore-block").forEach(block => {
    const content = block.querySelector(".readmore-content");
    const toggle = block.querySelector(".readmore-toggle");
    const labelMore = toggle.querySelector(".label-more");
    const labelLess = toggle.querySelector(".label-less");

    const maxLines = parseInt(block.dataset.maxLines) || 5;
    content.style.WebkitLineClamp = String(maxLines);

    const compute = () => {
      const clone = content.cloneNode(true);
      clone.style.cssText = `
        visibility:hidden;
        position:absolute;
        pointer-events:none;
        max-height:none;
        display:block;
        -webkit-line-clamp:unset;
      `;
      document.body.appendChild(clone);

      const fullHeight = clone.getBoundingClientRect().height;
      const lineHeight = parseFloat(getComputedStyle(content).lineHeight);
      const allowed = lineHeight * maxLines;

      document.body.removeChild(clone);
      return { fullHeight, allowed };
    };

    const { fullHeight, allowed } = compute();

    if (fullHeight <= allowed) {
      toggle.hidden = true;
      return;
    }

    block.classList.add("is-clamped");
    content.style.maxHeight = allowed + "px";
    content.id = "readmore-" + block.id + "-content";
    toggle.setAttribute("aria-controls", content.id);

    let open = false;

    const update = () => {
      if (open) {
        block.classList.add("is-expanded");
        block.classList.remove("is-clamped");
        toggle.setAttribute("aria-expanded", "true");
        labelMore.hidden = true;
        labelLess.hidden = false;

        content.style.maxHeight = "none";
        content.style.WebkitLineClamp = "unset";
      } else {
        block.classList.add("is-clamped");
        block.classList.remove("is-expanded");
        toggle.setAttribute("aria-expanded", "false");
        labelMore.hidden = false;
        labelLess.hidden = true;

        const { allowed } = compute();
        content.style.maxHeight = allowed + "px";
        content.style.WebkitLineClamp = String(maxLines);
      }
    };

    toggle.addEventListener("click", () => {
      open = !open;
      update();
    });
  });
});

// subcollection slider


function initSubcollectionSlider() {
  const container = document.querySelector(".cst_inner_connect");
  if (!container) return;

  const enableSlider = container.dataset.enableSlider === "true";
  if (!enableSlider) return;

  // Avoid double-init
  if (container._subcollectionSlider) return;

  let sliderInstance = null;

  function isOverflowing() {
    return container.scrollWidth > container.clientWidth;
  }

  function getGap() {
    return parseInt(getComputedStyle(container).getPropertyValue('--subcollection-gap')) || 8;
  }

  function enable() {
    if (sliderInstance) return;

    const items = Array.from(container.children);
    const wrapper = document.createElement("div");
    wrapper.className = "swiper-wrapper";

    items.forEach(item => {
      item.classList.add("swiper-slide");
      wrapper.appendChild(item);
    });

    container.classList.add("swiper", "swiper-container");
    container.appendChild(wrapper);

    document.querySelector(".subcollection-swiper-controls").style.display = "block";

    sliderInstance = new window.FoxTheme.Carousel(container, {
      slidesPerView: "auto",
      spaceBetween: getGap(),
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      }
    });

    sliderInstance.init();
  }

  function disable() {
    if (!sliderInstance) return;

    sliderInstance.destroy();
    sliderInstance = null;

    const wrapper = container.querySelector(".swiper-wrapper");
    if (wrapper) {
      while (wrapper.firstChild) {
        wrapper.firstChild.classList.remove("swiper-slide");
        container.appendChild(wrapper.firstChild);
      }
      wrapper.remove();
    }

    container.classList.remove("swiper", "swiper-container");
    document.querySelector(".subcollection-swiper-controls").style.display = "none";
  }

  function update() {
    if (isOverflowing()) enable();
    else disable();
  }

  const observer = new ResizeObserver(update);
  observer.observe(container);
  update();

  container._subcollectionSlider = { destroy: () => { disable(); observer.disconnect(); } };
}

document.addEventListener("DOMContentLoaded", initSubcollectionSlider);
document.addEventListener("shopify:section:load", initSubcollectionSlider);
